import { createStyles } from "@mantine/core"

export const useStyles = createStyles((theme) => ({
    container: {
        gap: "1.5rem",
        padding: "1.5rem",
        height: "calc(100dvh - var(--header-height))",
        position: "relative",
        // The Icon in the Search Input is rendering above the AIChatFlyout.
        // This fix will almost certainly cause something else to break down the line, but here we are.
        zIndex: 0,
    },
    pwaContainer: {
        height: "calc(100dvh - var(--header-height))",
        position: "relative",
        overflow: "hidden",
    },
    contentContainer: {
        height: "100%",
        overflowX: "hidden",
        overflowY: "auto",
        padding: "1.5rem",
    },
    gridCol: {
        maxWidth: "50%",
    },
    searchInput: {
        input: {
            boxShadow: "0px 4px 12px -4px rgba(0, 0, 0, 0.20)",
            border: `1px solid ${theme.colors.gray[2]}`,
        },
    },
    carousel: {
        // Remove the padding from container
        margin: "0 -1.5rem",
        overflow: "scroll",
        display: "flex",

        "&::-webkit-scrollbar": {
            background: "transparent",
            width: 0,
            height: 0,
        },
    },
    quickActions: {
        // Re-apply the padding as a starting point
        padding: "0.25rem 1.5rem",
        gap: "0.75rem",
        letterSpacing: ".0625rem",
        fontWeight: 500,
    },
    searchButton: {
        flex: 1,
        backgroundColor: theme.colors.violet[1],
    },
    lowerScreenButtonContainer: {
        width: "100%",
        display: "flex",
        alignItems: "flex-end",
        padding: "0 1.5rem 1.5rem",
    },
    logout: {
        display: "flex",
        alignItems: "flex-end",
        alignSelf: "center",
        flexGrow: 1,
    },
    logoutButton: {
        padding: ".5rem 1rem",
    },
    searchLinks: {
        display: "flex",
        flexDirection: "column",
        gap: ".5rem",
    },
    pwaSearchLinks: {
        display: "flex",
        flexDirection: "column",
        gap: ".5rem",
        paddingTop: "0.5rem",
    },
    searchLink: {
        display: "flex",
        padding: "1rem",
        gap: "1rem",
        alignItems: "center",
        borderRadius: ".25rem",
        border: `1px solid ${theme.colors.gray[3]}`,
        fontSize: "1rem",
        lineHeight: 1,
        color: theme.colors.gray[7],

        "&& svg": {
            fontSize: ".875rem",
            width: ".875rem",
        },
    },
    pwaSearchLink: {
        display: "flex",
        padding: "0.75rem",
        gap: "0.5rem",
        alignItems: "center",
        borderRadius: ".5rem",
        border: `1px solid ${theme.colors.gray[1]}`,
        fontSize: theme.fontSizes.xs,
        lineHeight: theme.lineHeight,
        color: theme.colors.gray[8],

        "&& svg": {
            fontSize: theme.fontSizes.md,
            width: "1rem",
        },
    },
    pwaRecentItems: {
        display: "flex",
        flexDirection: "column",
        gap: 0,
        padding: "0.5rem 0.25rem 0",
    },
    recentItemWrapper: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0.25rem 0",
        fontSize: theme.fontSizes.sm,
        color: theme.colors.gray[7],
        width: "100%",
        gap: "0.75rem",
    },
    recentItemButton: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "0.75rem",
        color: theme.colors.gray[7],
        width: "100%",
        height: "3rem",
    },
    recentItemIconContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "2rem",
        minWidth: "2rem",
        height: "2rem",
        borderRadius: "50%",
        backgroundColor: theme.colors.gray[1],
    },
    recentItemText: {
        display: "-webkit-box",
        WebkitBoxOrient: "vertical",
        WebkitLineClamp: 2,
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
    noRecentContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "1.5rem",
        paddingTop: "1.875rem",
    },
    noRecentIcon: {
        width: "2rem",
        height: "2rem",
        color: theme.colors.violet[5],
    },
    noRecentTitle: {
        fontSize: "1.75rem",
        fontWeight: 500,
        lineHeight: "2.25rem",
        paddingBottom: "0.5rem",
        textAlign: "center",
    },
    noRecentText: {
        fontSize: theme.fontSizes.sm,
        textAlign: "center",
    },
    tabsRoot: {
        overflow: "hidden",
        paddingTop: "1.5rem",
        paddingLeft: "2px",
    },
}))
